module.exports = __webpack_public_path__ + "static/img/s101.37c1c4ac.png";